import Api from './Api';

class StudioServices {
	getBitfishDoc = async () => await Api.get('studio/api/bitfish-doc/');
}

export default new StudioServices();
